// @ts-nocheck

import * as React from 'react';
import moment from 'moment';

import css from './expired.css';


const ExpiredPage = ({
  color,
  expiredAt,
}: {
  color?: string;
  expiredAt: string;
}) => (
  <div className={css.container}>
    <div className={css.messageBox}>
      <div className={css.message}>
        Thank you!
        <br />
        {`Unfortunately this survey expired on 
        ${moment(expiredAt).format('D MMM, YYYY')}.`}
      </div>
    </div>

    <img className={css.hourGlass} src="/images/hourglass-nobg.png" />
  </div>
);

export default ExpiredPage;
